import type { Dictionary } from './en';

/**
 * Spanish translation — baseline for shipping; should be reviewed by a
 * native ES speaker before production. See i18n/CHECKLIST.md.
 */
const es: Dictionary = {
  brand: 'ArriveSafe',
  meta: {
    titleDefault: 'ArriveSafe',
    titleTravelling: 'ArriveSafe – Sigue a {name} en su camino',
    titleArrived: 'ArriveSafe – {name} llegó bien',
    titleEmergency: 'ArriveSafe – {name} activó una emergencia',
  },
  social: {
    titleDefault: 'Comparto mi ubicación',
    descriptionDefault: 'Acompáñame hasta que llegue bien.',
    titleTravelling: '{name} está en camino',
    descriptionTravelling: 'Sigue a {name} en directo hasta que llegue bien.',
    titleArrived: '{name} llegó bien',
    descriptionArrived: 'El trayecto ha terminado.',
  },
  status: {
    onTheWay: '{name} está en camino',
    onTheWayTo: '{name} está en camino a {destination}',
    arrived: '{name} llegó bien a las {time}',
    arrivedNoTime: '{name} llegó bien',
    emergency: '{name} activó una emergencia',
    titleSubtitle: '{name} está en camino',
  },
  transport: {
    foot: 'a pie',
    running: 'corriendo',
    bike: 'en bici',
    car: 'en coche',
    motorcycle: 'en moto',
    bus: 'en autobús',
    train: 'en tren',
    plane: 'en avión',
    boat: 'en barco',
    horse: 'a caballo',
    detecting: 'detectando…',
  },
  connection: {
    connecting: 'Conectando',
    live: 'En vivo',
    stale: 'Señal débil',
    offline: 'Sin conexión',
  },
  stats: {
    battery: 'Batería',
    speed: 'Velocidad',
    avgSpeed: 'Vel. media',
    distance: 'Distancia',
    time: 'Hora',
    startAddress: 'Salida',
    finishAddress: 'Llegada',
    lastUpdate: 'Actualizado hace {seconds} s',
    lastUpdateMin: 'Actualizado hace {minutes} min',
    justUpdated: 'Justo ahora',
  },
  welcome: {
    prompt: '{name} te ha invitado como acompañante.',
    askName: '¿Con qué nombre quieres aparecer?',
    nameLabel: 'Tu nombre',
    save: 'Guardar nombre',
    skip: 'Saltar',
    watchingAs: 'Mirando como {name}',
    setYourName: 'Indicar tu nombre',
  },
  download: {
    title: 'Descargar ArriveSafe',
    blurb: 'Comparte tus propios trayectos con tus seres queridos.',
    ios: 'App Store',
    android: 'Google Play',
    chip: 'Obtener la app',
    chipDismiss: 'Cerrar',
    iosCta: 'Descargar en App Store',
    androidCta: 'Descargar en Google Play',
    otherCta: 'Descargar ArriveSafe',
  },
  loading: {
    title: 'Cargando trayecto…',
    verifying: 'Verificando código…',
    fetching: 'Cargando ruta…',
  },
  empty: {
    notFound: 'No se encontró este trayecto.',
    noCode: 'Abre esta página con un código de viaje: {url}',
    error: 'Algo salió mal: {message}',
  },
  playback: {
    play: 'Repetir el camino',
    playing: 'Reproduciendo…',
    pause: 'Pausa',
    resume: 'Reanudar',
    replay: 'Repetir el camino',
    pausedAt: 'En pausa a las {time}',
  },
  timeline: {
    title: 'Registro del trayecto',
    close: 'Cerrar',
    routeStarted: 'Trayecto iniciado',
    batteryDrop: 'Batería al {battery}%',
    stationary: 'Sin moverse desde hace {duration}',
    stillEnRoute: 'Sigue en camino',
    stillEnRouteProgress: 'Sigue en camino · {progress}%',
    arrived: 'Llegó',
    emergency: 'Emergencia activada',
    emergencyAlerted: 'Emergencia activada · {count} contactos avisados',
    companionJoined: '{name} acompaña el trayecto',
    companionJoinedUnnamed: 'Se unió un acompañante',
  },
  emergency: {
    bannerActive: '{name} activó una emergencia',
    bannerCleared: '{name} se marcó a salvo a las {time}',
    triggeredAgo: 'hace {relative}',
    lastKnown: 'Última ubicación conocida',
    callServices: 'Llamar a emergencias ({number})',
    copyLocation: 'Copiar ubicación',
    openInMaps: 'Abrir en Mapas',
    enableAlerts: 'Toca para activar las alertas sonoras',
    wrongCountry: '¿País equivocado? Cambiar',
  },
  ariaLive: {
    travelling: '{name} está en camino.',
    arrived: '{name} llegó bien.',
    emergency: '{name} activó una emergencia. Última ubicación conocida: {location}.',
  },
};

export default es;
